import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { Typography, Box, Paper, Link } from "@mui/material";

import ArrowRightIcon from "../icons/ArrowRightIcon";

const ThankYouPageResourceCard = ({
  IconComponent,
  title,
  description,
  linkHref,
  linkText,
}) => {
  const theme = useTheme();

  const cardSx = {
    backgroundColor: theme.palette.plum100,
    p: { xs: 4, md: 4 },
    borderRadius: "16px",
    minHeight: { md: 208, lg: 220 },
    display: "flex",
    flexDirection: "column",
    height: "100%",
  };

  const linkStyles = {
    color: theme.palette.primary.main,
    fontWeight: 700,
    fontSize: 16,
    fontFamily: "Public Sans, sans-serif",
    textDecoration: "underline",
    textUnderlineOffset: "4px",
    textDecorationThickness: "1px",
    outline: "1px dashed transparent",
    p: "1px",
    ":focus": {
      outline: `1px dashed ${theme.palette.secondary.main}`,
    },
    "&:hover": {
      color: theme.palette.tertiary.main,
      textDecorationColor: theme.palette.tertiary.main,
    },
  };

  return (
    <Paper elevation={0} sx={cardSx}>
      <Box sx={{ mb: 2, lineHeight: 0 }}>
        <IconComponent
          fill={theme.palette.tertiary.main}
          sx={{ fontSize: 30 }}
        />
      </Box>

      <Typography
        sx={{
          fontFamily: "Public Sans, sans-serif",
          fontWeight: 800,
          fontSize: 25,
          lineHeight: "140%",
          mb: 2,
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          fontFamily: "Public Sans, sans-serif",
          fontWeight: 400,
          fontSize: 16,
          lineHeight: "180%",
          color: theme.palette.secondary.main,
        }}
      >
        {description}
      </Typography>

      <Box sx={{ mt: "auto" }}>
        <Link
          href={linkHref}
          target="_blank"
          rel="noopener noreferrer"
          underline="always"
          sx={linkStyles}
        >
          {linkText}
          <ArrowRightIcon sx={{ fontSize: 25, pl: 1, pb: "1px" }} />
        </Link>
      </Box>
    </Paper>
  );
};

ThankYouPageResourceCard.propTypes = {
  IconComponent: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  linkHref: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
};

export default ThankYouPageResourceCard;
